var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { MessageBanner } from "@folio/stripes/components";
import { FormattedMessage } from "react-intl";
import { otherAgenda } from "../../types/agenda";
export var SkippedHandledElsewhere = function (_a) {
    var count = _a.count, listedIn = _a.listedIn, _b = _a.executed, executed = _b === void 0 ? false : _b, onDismiss = _a.onDismiss;
    return count ? (React.createElement(MessageBanner, __assign({ type: "default" }, (onDismiss ? { dismissible: true, onExited: onDismiss } : {}), { "data-test-id": "agenda-bulk-skipped" }),
        React.createElement(FormattedMessage, { id: executed
                ? "ui-br-legaldeposits.agenda.bulk.skippedExecuted"
                : "ui-br-legaldeposits.agenda.bulk.skipped", values: { count: count, handler: otherAgenda(listedIn) } }))) : null;
};
